import type { TimelineTrackItem } from "@/shared/components/Timeline";
import type { SessionRecord } from "@/shared/domain/sessions/SessionRecord";
import { nanoSecToMilliSecLossy } from "@/shared/time";

export const UNTITLED_SESSION = "Untitled session";

export interface SessionTracks {
  /** Sessions with a time range, as timeline items in ms. */
  items: TimelineTrackItem<SessionRecord>[];
  /** Sessions with no files yet: no time range, so no place on the timeline (R-6). */
  untimed: SessionRecord[];
}

/**
 * Split a device's sessions into what the timeline can place and what it
 * cannot. Bounds are nanosecond bigints on the record; the timeline works in
 * milliseconds, which keeps second-level precision (R-11).
 */
export function toSessionTracks(
  sessions: readonly SessionRecord[],
): SessionTracks {
  const items: TimelineTrackItem<SessionRecord>[] = [];
  const untimed: SessionRecord[] = [];
  for (const session of sessions) {
    if (
      session.min_timestamp_ns === null ||
      session.max_timestamp_ns === null
    ) {
      untimed.push(session);
      continue;
    }
    items.push({
      id: session.session_id,
      label: session.name ?? UNTITLED_SESSION,
      startTime: nanoSecToMilliSecLossy(session.min_timestamp_ns),
      endTime: nanoSecToMilliSecLossy(session.max_timestamp_ns),
      data: session,
    });
  }
  return { items, untimed };
}
